import { Box, Typography } from '@mui/material';
import { getBusinessFriendlyFieldName, getBusinessFriendlyFieldValue } from './utils';
import React from 'react';
import { isAsset, isVixImage } from '../../../utils/regex';
import { getAssetUrl } from '../../../utils/assetHelpers';
import Localized from '../../shared/Localized';
import { LocalizedFieldBody } from '../../../API';
import { MenuItemsComparison } from './MenuItemsComparison';

export function TooltipTitleUiModuleChange({
  fieldName,
  oldValue,
  newValue
}: {
  fieldName: string;
  oldValue: string | null | undefined | object;
  newValue: string | null | undefined | object;
}): React.ReactElement {
  const fileNameFormatted = getBusinessFriendlyFieldName(fieldName);

  // Special handling for menuItems field
  if (fieldName === 'menuItems') {
    return (
      <Box display="flex" flexDirection="column" gap={1} sx={{ padding: 4 }}>
        <Typography variant="subtitle1" color="white" fontWeight="bold">
          {fileNameFormatted}
        </Typography>
        <MenuItemsComparison oldValue={oldValue} newValue={newValue} />
      </Box>
    );
  }

  const oldValueFormatted = getFormattedValue(oldValue);
  const newValueFormatted = getFormattedValue(newValue);

  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Typography variant="body2" color="white" fontWeight="bold">
        {fileNameFormatted}
      </Typography>
      <Typography variant="body2" color="white" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {oldValueFormatted} → {newValueFormatted}
      </Typography>
    </Box>
  );
}

const getFormattedValue = (value: string | null | undefined | object): string | React.ReactNode => {
  if (typeof value === 'string' && isAsset(value)) {
    return <img src={`${getAssetUrl(value)}?tr=h-100`} />;
  }
  if (typeof value === 'string' && isVixImage(value)) {
    return <img src={`${value}?tr=h-100`} />;
  }
  if (isLocalized(value)) {
    return <Localized prop={value as LocalizedFieldBody} />;
  }
  return getBusinessFriendlyFieldValue(value);
};

const isLocalized = (value: string | null | undefined | object): boolean => {
  if (!value || typeof value !== 'object' || Object.keys(value).length === 0) return false;
  return 'es' in value || 'en' in value || 'pt' in value;
};
